<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col p-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="row">
    <div class="col-12">
      <h4 class="mb-2 py-1 font-header-1">Group Payer Service</h4>
    </div>
    <div class="col">
      <div class="card">

        <div class="card-body">
          <div class="row mb-2">
            <div class="col-12 py-2 d-flex justify-content-between"> <span> <button type="button" class="btn btn-sm"
                  (click)="CreateOrUpdate('new')" data-bs-toggle="modal" data-bs-target="#savePayorMap"
                  *ngIf="fp.grouppayerservicecreate">

                  Add Group Payer Service </button></span>

              <span><button class="btn btn-sm" (click)="refresh()"> <i class="fa fa-repeat"> </i>Refresh
                </button></span>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col">
              <ejs-grid #grid [dataSource]="gridServiceMapping | async" [allowPaging]='true'
                [pageSettings]='initialPage' [filterSettings]='filterSettings' [allowFiltering]='true'
                [allowResizing]='true' [allowSorting]='true' (dataStateChange)='dataChangeServiceMapping($event)'
                [showColumnChooser]='true' (actionBegin)="onActionServiceMapping($event);">
                <e-columns>
                  <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table" data-bs-target="#savePayorMap" data-bs-toggle="modal"
                        (click)="CreateOrUpdate('edit');getDetails(data)" *ngIf="fp.grouppayerserviceupdate"><i
                          class="fa fa-edit"></i></button>&nbsp;
                      <button class="btn btn-delete-table" data-bs-target="#DeletePayorMap" data-bs-toggle="modal"
                        (click)="getDetails(data)"><i class="fa fa-trash"
                          *ngIf="fp.grouppayerservicedelete"></i></button>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="groupName" headerText="Group" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="payerName" headerText="Payer" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="serviceName" headerText="Service" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="serviceDescription" headerText="Service Description" type="string"
                    [allowFiltering]='true' [allowSorting]='true'>
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="renderingProviderLovName" headerText="Rendering Provider ID"
                    type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="g2Id" headerText="G2 Id" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="atypical" headerText="Atypical" type="boolean">
                    <ng-template #filterTemplate let-data>
                      <!-- <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox> -->
                      <ejs-dropdownlist id='dropdata3'
                      placeholder='Select Atypical'
                      [dataSource]='dropdatas'
                      [popupHeight]='height'></ejs-dropdownlist>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="combineClaim" headerText="Combine Claim" type="boolean">
                    <ng-template #filterTemplate let-data>
                      <!-- <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox> -->
                      <ejs-dropdownlist id='dropdata3'
                      placeholder='Select Combine Claim'
                      [dataSource]='dropdatas'
                      [popupHeight]='height'></ejs-dropdownlist>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="waiver" headerText="Waiver" type="boolean">
                    <ng-template #filterTemplate let-data>
                      <!-- <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox> -->
                      <ejs-dropdownlist id='dropdata3'
                      placeholder='Select Atypical'
                      [dataSource]='dropdatas'
                      [popupHeight]='height'></ejs-dropdownlist>
                    </ng-template>
                  </e-column>

                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div>
                        <span id='show' (click)="showColumns()"><i class="fa fa-cog fa-lg" aria-hidden="true">
                          </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<!-------------------------------------------------Save Modal------------------------------------- -->
<span id="exampleModalSave" data-bs-toggle="modal" data-bs-target="#savePayorMap"></span>
<div class="modal fade modalbackgrod" id="savePayorMap" tabindex="-1" data-bs-backdrop="false"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"><span *ngIf="modalType == 'new'"> Save Payer Service Mapping
          </span>
          <span *ngIf="modalType == 'edit'">Update Payer Service Mapping </span>
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="reset()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="payorMapForm">
          <div class="row">
            <div class="col-6">
              <div class="row mb-3">
                <div class="col-3">
                  <label>Group <sup class="super-script">*</sup></label>
                </div>
                <div class="col-8">

                  <ng-select class="w-70" style="color: black;" [clearable]="false" [searchable]="true"
                    [items]="groupList" bindLabel="lovName" [(ngModel)]="groupId" formControlName="group"
                    (ngModelChange)="onGroupChange(groupId)" bindValue="id">
                  </ng-select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <label>Payer<sup class="super-script">*</sup> </label>
                </div>
                <div class="col-8">
                  <ng-select class="w-70" style="color: black;" [clearable]="false" [searchable]="true"
                    [items]="payerData" bindLabel="Value" [(ngModel)]="savePayorData.payerId" formControlName="Payer"
                    (ngModelChange)="getPayer(groupId)" bindValue="Key">
                  </ng-select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <label>Service <sup class="super-script">*</sup></label>
                </div>
                <div class="col-8">
                  <ng-select class="w-70" style="color: black;" [(ngModel)]="savePayorData.serviceId"
                    [clearable]="false" [searchable]="true" [items]="getserviceData" formControlName="service"
                    bindLabel="Value" (ngModelChange)="getDescription(savePayorData.serviceId)" bindValue="Key">
                  </ng-select>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <label>Description </label>
                </div>
                <div class="col-8">
                  <input class="form-control" disabled type="text" formControlName="Description"
                    [(ngModel)]="getdescriptionData">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-3">
                  <label>Rendering Provider ID Requirements<sup class="super-script">*</sup></label>
                </div>
                <div class="col-8">
                  <ng-select class="w-70" style="color: black;" [(ngModel)]="savePayorData.renderingProviderLid"
                    formControlName="ProviderId" [clearable]="false" [searchable]="true" [items]="groupofList"
                    bindLabel="lovName" bindValue="id">
                  </ng-select>
                </div>
              </div>
            </div>

            <div class="col-6">
              <div class="row mb-3">
                <div class="col-4">
                  <label>G2 Id </label>
                </div>
                <div class="col-8">
                  <input class="form-control" type="text" formControlName="G2id" min="5" max="15"
                    [(ngModel)]="savePayorData.g2Id">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <label>Atypical </label>
                </div>
                <div class="col-8">
                  <input type="checkbox" formControlName="Atypical" [(ngModel)]="savePayorData.atypical">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <label>Waiver </label>
                </div>
                <div class="col-8">
                  <input type="checkbox" formControlName="Waiver" [(ngModel)]="savePayorData.waiver">
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-4">
                  <label>Combine Claim </label>
                </div>
                <div class="col-8">
                  <input type="checkbox" formControlName="CombineClaim" [(ngModel)]="savePayorData.combineClaim">
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" [disabled]="payorMapForm.invalid|| isSaveorUpdateBoolean" (click)="SaveGroupPayerMapping()" class="btn btn-sm">
          <span *ngIf="modalType == 'new'"> Save & Close</span>
          <span *ngIf="modalType == 'edit'"> Update & Close</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-------------------------------------------------Delete------------------------------------------------------------>
<span id="deleteModal" data-bs-toggle="modal" data-bs-target="#DeletePayorMap"></span>
<div class="modal fade modalbackgrod" id="DeletePayorMap" tabindex="-1" data-bs-backdrop="false"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5 err" id="exampleModalLabel">Delete Record! </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="reset()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <h5>Do you want to delete this record ?</h5>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="DeletePayorMapping()" class="btn btn-sm">Delete</button>
      </div>
    </div>
  </div>
</div>